module.exports = __webpack_public_path__ + "static/media/button-close-hover.97e52610.svg";